<template>
  <div class="loader"
    :class="{'final-countdown': finalCountdown }"
    :style="{'transition-duration': `${loaderTransitionDuration}ms`}">
    <div
      class="loader-content">
      <transition-group name="fade-delayed">
        <div
          id="loader-time"
          class="loader-time"
          key="time"
          v-show="countdownActive"
        >{{ !countdownActive ? '' : formattedCountdownTime }}</div>
        <div
          id="loader-message"
          class="loader-message"
          key="message"
          data-trans="loading"
        >{{ infoMessage }}</div>
      </transition-group>
    </div>
    <div class="product-name-wrap">
      <div class="product-name">{{ title }}</div>
    </div>
    <div class="loader-progressbar-wrap">
      <div
        id="loader-progressbar"
        class="loader-progressbar"
        :style="{ transform: `translateX(${progressWidth}%`}"
      ></div>
    </div>
  </div>
</template>

<script>
import { formatTime } from '../utility';

export default {
  name: 'AppLoader',
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: 'Game title',
    },
    infoMessage: {
      type: String,
      default: '',
    },
    countdownTime: {
      type: Number,
      default: 0,
    },
    countdownActive: {
      type: Boolean,
      default: false,
    },
    progressStartValue: {
      type: Number,
      default: 0,
    },
    progressFullWidth: {
      type: Boolean,
      default: false,
    },
    loaderTransitionDuration: {
      type: Number,
      default: 1000,
    }
  },
  computed: {
    progressWidth() {
      return !this.progressFullWidth
        ? (this.countdownTime / this.progressStartValue) * 100 - 100 : 0;
    },
    formattedCountdownTime() {
      return formatTime(this.countdownTime);
    },
    finalCountdown() {
      return this.countdownTime <= 10 && this.countdownTime > 0;
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.loader {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(29, 33, 36, 0.9);
  font-family: 'Roboto';
  transform: translateY(calc(-100vh + #{$header-loader-height-sm}));
  transition: all 1s cubic-bezier(0.23, 1, 0.32, 1);
  z-index: -1;
  backface-visibility: hidden;

  .product-name-wrap {
    position: absolute;
    top: 58vh;
    left: 0;
    width: 100%;
    text-align: center;
    opacity: 0;
    transition: opacity 0.5s;
  }

  .product-name {
    position: relative;
    display: inline-block;
    width: 46vw;
    line-height: 1.1;
    color: #f0f0f0;
    text-align: center;
    font: {
      family: 'Nunito', sans-serif;
      size: 4vw;
      weight: 700;
    }
    vertical-align: middle;
    backface-visibility: hidden;
  }
}

.loader-content {
  width: 100%;
  opacity: 0;
  text-align: center;
  text-transform: uppercase;
  transition: opacity 0.5s 0.75s;
}

.loader-time {
  position: absolute;
  bottom: 12vh;
  width: 100%;
  font-size: 32px;
  color: #fff;
}

.loader-message {
  position: absolute;
  bottom: 5vh;
  width: 100%;
  font-size: 14px;
  color: #3b3b3b;
}

.loader-progressbar-wrap {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: $progressbar-height-sm;
  background-color: rgba(255, 255, 255, 0.2);
}

.loader-progressbar {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.5);
  backface-visibility: hidden;
  transition: all 1s linear;
}

.final-countdown .loader-progressbar {
  background-color: rgba(230, 100, 90, 0.5);
}

.stream-runner-mode {
  .loader {
    transform: translateY(calc(-100vh + #{$header-loader-height-xl}));
  }
}

@media screen and (min-width: $breakpoint-mobile) {
  .loader {
    transform: translateY(calc(-100vh + #{$header-loader-height-md}));

    .product-name-wrap {
      top: 55vh;
    }

    .product-name {
      width: 38vw;
      font-size: 2.8vw;
    }

    .loader-progressbar-wrap {
      height: $progressbar-height-md;
    }
  }
}

@media screen and (min-width: $breakpoint-web) {
  .loader {
    transform: translateY(calc(-100vh + #{get-vw($header-loader-height-md, $viewport-width-web)}));
  }
}

@media screen and (min-width: $breakpoint-desktop) {
  .loader {
    transform: translateY(calc(-100vh + #{get-vw($header-loader-height)}));

    .loader-progressbar-wrap {
      height: $progressbar-height;
    }

    .loader-time {
      font-size: get-vw(32px);
    }

    .loader-message {
      font-size: get-vw(14px);
    }
  }
}

@media screen and (min-width: $breakpoint-desktop-max) {
  .loader {
    transform: translateY(calc(-100vh + #{get-vw($header-loader-height-max, $viewport-width-max)}));

    .loader-progressbar-wrap {
      height: $progressbar-height-max;
    }
  }
}

.animations-none {
  .loader {
    transition: none;
  }
}

.loader-on {
  .loader {
    transform: translateY(0);
    background-color: rgba(29, 33, 36, 1);

    .product-name-wrap {
      opacity: 1;
      transition: opacity 0.5s 0.75s;
    }
  }

  .loader-content {
    opacity: 1;
  }

  @media screen and (min-width: $breakpoint-mobile-md) {
    .loader-time {
      font-size: 42px;
    }
  }

  @media screen and (min-width: $breakpoint-mobile) {

    .loader-time {
      font-size: 48px;
    }

    .loader-message {
      font-size: 16px;
    }
  }

  @media screen and (min-width: $breakpoint-web-md) {
    .loader-time {
      font-size: 52px;
    }

    .loader-message {
      font-size: 18px;
    }
  }

  @media screen and (min-width: $breakpoint-web) {
    .loader-time {
      font-size: 60px;
    }

    .loader-message {
      font-size: 20px;
    }
  }

  @media screen and (min-width: $breakpoint-desktop) {

    .loader-time {
      font-size: get-vw(70px);
    }

    .loader-message {
      font-size: get-vw(24px);
    }
  }

  @media screen and (min-width: $breakpoint-desktop-xl) {
    .loader-time {
      font-size: 90px;
    }

    .loader-message {
      font-size: 30px;
    }
  }

  &.animations-none {
    .product-name-wrap {
      transition-delay: 0.1s;
    }
  }
}

.loader-off {
  .loader {
    transition-delay: 0.3s;

    .product-name-wrap {
      opacity: 0;
      transition: opacity 0.3s;
    }
  }

  .loader-content {
    transition-duration: 0s;
    transition-delay: 0s;
  }

  &.animations-none {
    .loader {
      transition: 0s;
    }
  }
}
</style>
